import * as THREE from "three";
import { useEffect, useCallback, useRef, useState } from "react";
import {useSitePropertiesStore} from "../../store/useGeometryPropertiesStore.js"
import { useMapStore } from "../../store/useMapStore.js";
import { useBoundingBoxStore } from "../../store/useBoundingBoxStore.js";
import { wgs84ToWebMercator } from "../../services/CoordinateTransformService.js";
import fetchRiskAreaData from "./RiskAreaqueries.js";
import PolygonPlane from "./SiteGeometry.jsx";
import { useSiteExportStore } from "../../store/useSiteExport.js";
import { useLayerStore } from "../../store/useLayerStore.js";
import fetchBPlanData from "./BPlanqueries.js";
import fetchLanduseData from "./LandUsequeries.js";
import { useLandusePropertiesStore } from "../../store/useGeometryPropertiesStore.js";
import { useGeometryTypeStore } from "../../store/useGeometryPropertiesStore.js";
import { CacheGeometry,  LoadFromCache,GetCacheKey, ClearCache } from "../../utils/GeometryHelper.js";
import { GeometryType } from "../../constants/progress.js";



export default function LanduseGeometry() 
{
  const geometryType = GeometryType.LANDUSE;
  const { setGeometryType } = useGeometryTypeStore();
  const scalingFactor = useMapStore(state => state.scalingFactor);
  const [landuseEntities, setLanduseEntities] = useState([]);  
  const [usedata, setData] = useState([]);  
  const [visibility, setVisibilty] = useState(false);
  const [inputColor,setInputColor] = useState("#CBA2A2");
  const [crs, setCrs] = useState("EPSG3857"); 
  const {infrastruktur_verkehr,
  bauwerke_anlagen,
  gewaesser,
  naturraeume_vegetation,
  rohstoff_bergbau,
  schutz_recht_festlegung,
  siedlungs_und_nutzung} = useLayerStore((state) => state.visibleLayers);
  const updateLandusePropertyStore = useLandusePropertiesStore((state)=> state.updateLanduseProperties)
  const boundingBoxNE = useBoundingBoxStore(state => state.ne);
  const boundingBoxSW = useBoundingBoxStore(state => state.sw);
  const metersPerPixel = useMapStore(state => state.metersPerPixel);
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const CACHE_KEY = "cacheLandUse";
  const CACHE_VERSION = "version_1";
  const cacheKey = GetCacheKey(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY,CACHE_VERSION)
  const anyLayerVisible = Object.values({
  infrastruktur_verkehr,
  bauwerke_anlagen,
  gewaesser,
  naturraeume_vegetation,
  rohstoff_bergbau,
  schutz_recht_festlegung,
  siedlungs_und_nutzung
  }).some(Boolean);
 

      const fetchData = async () => {
     if(anyLayerVisible)
     {
       try {
        let data = LoadFromCache (cacheKey, CACHE_VERSION, 1000 * 60 * 60 * 24) 
        if(!data)
        {
            data = await fetchLanduseData(
            boundingBoxNE.lng,
            boundingBoxNE.lat,
            boundingBoxSW.lng,
            boundingBoxSW.lat
          );
          if(data)
          {
            setData(data);
            ClearCache(CACHE_KEY); // not using the exact key here
            CacheGeometry(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY, CACHE_VERSION, data)
            console.log("Number of Landuse entities recieved",data);
          }
        }
        else{
          setData(data);

        }
      
      } catch (error) {
        console.error('Failed to fetch data:', error);
        // Handle error (show notification, etc.)
      }
     }
    };

    const handleEntitySelect = (entity) => 
    {
      setSelectedEntityId(entity.id);
      setGeometryType(entity.Name);
      updateLandusePropertyStore(entity.type, entity.landuseType)
      
    };
  const handleBackgroundClick = () => 
    {
      setSelectedEntityId(null);
    };
    
    useEffect(()=>{  
        if (usedata)
        {
          let groupName = "";
          if(infrastruktur_verkehr)
          {
             const filteredValues = usedata
            .filter(item => item.groupName === "infrastruktur_verkehr")  // get only items in the group
            setLanduseEntities(filteredValues);
            setInputColor("#efcc97")
            setVisibilty(true);
          }
          else if(bauwerke_anlagen)
          {
             const filteredValues = usedata
            .filter(item => item.groupName === "bauwerke_anlagen")  // get only items in the group
            setLanduseEntities(filteredValues);
            setInputColor("#bca9d0")
            setVisibilty(true);
          }
          else if(gewaesser)
          {
             const filteredValues = usedata
            .filter(item => item.groupName === "gewaesser")  // get only items in the group
            setLanduseEntities(filteredValues);
            setInputColor("#91bed3")
            setVisibilty(true);
          }
          else if(naturraeume_vegetation)
          {
             const filteredValues = usedata
            .filter(item => item.groupName === "naturraeume_vegetation")  // get only items in the group
            setLanduseEntities(filteredValues);
            setInputColor("#c5cc9e")
            setVisibilty(true);
          }
          else if(rohstoff_bergbau)
          {
            const filteredValues = usedata
            .filter(item => item.groupName === "rohstoff_bergbau")  // get only items in the group
            setLanduseEntities(filteredValues);
            setInputColor("#9faa5e ")
            setVisibilty(true);
          }
          else if(schutz_recht_festlegung)
          {
             const filteredValues = usedata
            .filter(item => item.groupName === "schutz_recht_festlegung")  // get only items in the group
            setLanduseEntities(filteredValues);
            setInputColor("#87cac4")
            setVisibilty(true);
          }
          else if(siedlungs_und_nutzung)
          {
             const filteredValues = usedata
            .filter(item => item.groupName === "siedlungs_und_nutzung")  // get only items in the group
            setLanduseEntities(filteredValues);
            setInputColor("#edb19e")
            setVisibilty(true);
          }
          else{
           setVisibilty(false);
          }
        }
      },[infrastruktur_verkehr,
        bauwerke_anlagen,
        gewaesser,
        naturraeume_vegetation,
        rohstoff_bergbau,
        schutz_recht_festlegung,
        siedlungs_und_nutzung, usedata]);

  useEffect(() => 
   {
      fetchData(); 
   }, [anyLayerVisible]);

  return (
    <>
      <group onClick={handleBackgroundClick}>
      {landuseEntities.length > 0 && (
      <PolygonPlane 
        entities={landuseEntities}
        selectedEntityId={selectedEntityId}
        setSelectedEntityId={setSelectedEntityId}
        inputColor ={inputColor}
        inputVisibilty={anyLayerVisible}
        onEntitySelect={handleEntitySelect}
        className={"LanduseEntity"}
        crs={"EPSG3857"}
        geometryType={geometryType}
        zTransform = {[0,3,0]}
      />
    )}
    </group>
    </>
  );
}